import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPen$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPen extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '530621729df4ae8b075270f6506e24582973e70f', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '1380a8a672017ec873d6e4497c5f9e10dea34efa', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '44d5488b1800b00d7fb9da2120b88072cd7747d0', d: "M5.213 13.899 12.99 6.12l2.828 2.829-7.778 7.778-3.323 1.075a.5.5 0 0 1-.627-.639zm13.081-8.132c.195.195.222.485.06.648L16.88 7.888 14.052 5.06l1.473-1.473c.162-.163.453-.137.648.059z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-pen", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-pen"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-pen":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPen$1);
            }
            break;
    } });
}

const CosmosIconPen = CosmosIconPen$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPen, defineCustomElement };
